import { render, staticRenderFns } from "./FixedPhraseEditor.vue?vue&type=template&id=09c29e59&scoped=true&"
import script from "./FixedPhraseEditor.vue?vue&type=script&lang=ts&"
export * from "./FixedPhraseEditor.vue?vue&type=script&lang=ts&"
import style0 from "./FixedPhraseEditor.vue?vue&type=style&index=0&id=09c29e59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c29e59",
  null
  
)

export default component.exports